import React from 'react';
import FormsApp from './FormsApp';

const FormsSilhouette: React.FC = () => {
  return <FormsApp />;
};

export default FormsSilhouette;
